export const omdb = {
  url: 'http://www.omdbapi.com',
  key: '954b0c30',
};
export const tmdb = {
  url: 'https://api.themoviedb.org/3',
  key: 'f659fd5ffa5834a879a7eab0b069f5a8',
};
export const firebaseConfig = {
  apiKey: 'AIzaSyDi4H1wVE15D3rM0eqgJmt32D3e0L699Sw',
  authDomain: 'watchlist-3399e.firebaseapp.com',
  databaseURL: 'https://watchlist-3399e.firebaseio.com',
  projectId: 'watchlist-3399e',
  storageBucket: '',
  messagingSenderId: '384745791334',
};
